import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["tags", "topics", "owner"];
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * This function converts the changes submitted from the `PlaylistEditorModal` component
 * and converts them to the format required for the API call in `useUpdatePlaylists`.
 */

export function formatPlaylistEditorPayloadForApi(changes) {
  var tags = changes.tags,
    topics = changes.topics,
    owner = changes.owner,
    commonChanges = _objectWithoutProperties(changes, _excluded);
  var patchData = _objectSpread({}, commonChanges);
  if (tags) {
    patchData.tags = tags.map(function (tag) {
      return tag.id;
    });
  }
  if (topics) {
    patchData.topics = topics.map(function (topic) {
      return topic.id;
    });
  }
  if (owner !== undefined) {
    patchData.ownerId = (owner === null || owner === void 0 ? void 0 : owner.id) || null;
  }
  return patchData;
}